import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import ElementLine from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Preparations/Preparation/ElementsSection/ElementLine';
import type InternalInterviewListEntryView from '@UI/Pages/Beneficiaries/Hooks/useBeneficiaryInterviewsList/InternalInterviewListEntryView';
import LocalRecordingActions from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Preparations/Preparation/ElementsSection/LocalRecordingActions';
import type * as React from 'react';
import { Tag } from '@verclam/ui-kit';

type Props = {
	readonly entry: InternalInterviewListEntryView;
	readonly subject: SubjectAddress;
	readonly canEdit: boolean;
};

/** A recording made for this preparation that is still only on this device: « Non envoyé ». */
const LocalDraftRow: React.FC<Props> = ({ entry, subject, canEdit }) => {
	return (
		<ElementLine
			kind="interview"
			title={entry.title}
			subtitle={`${entry.hasName ? `${entry.conductedOnDisplay} · ` : ''}${entry.participantsDisplay}`}
			chip={<Tag rounded severity="warning" value="Non envoyé" />}
			footer={canEdit ? <LocalRecordingActions entry={entry} subject={subject} /> : undefined}
		/>
	);
};

export default LocalDraftRow;
